import router from '../services/router_service';
import videoModuleController from '../controllers/video_module_controller';

router.on('route:videomodule', videoModuleController);
